module.exports = __webpack_public_path__ + "img/banner-finantare.d335da0b.png";